declare global {
  interface Window {
    __weco: any;
  }
}

function legacyGetWeco(fn: any) {
  const useStrict = '"use strict";';
  const fnString = `require(['sitecoreweco'], function(w) { window.__weco = w })`;
  Function(useStrict + "return (" + fnString + ")")();

  function check() {
    if (window.__weco === undefined) {
      setTimeout(check, 1); //wait 1 millisecnds then recheck
      return;
    }
    fn(window.__weco);
    //delete window.__weco;
  }
  check();
}

export const legacyAddToCart = (
  itemNumber: string,
  quantity: number,
  scID: string,
  type: string,
) =>
  legacyGetWeco((w: any) => {
    const quoteType = w.wecoQuoteType;
    const orderType = w.wecoOrderType;
    const prType = type === "quote" ? quoteType : orderType;
    return w.wecoAddToCart(
      itemNumber,
      itemNumber,
      quantity,
      scID,
      undefined,
      undefined,
      prType,
      undefined,
      undefined,
    );
  });
